const state = {
  showLogin: false,
  isRegistered: 2,
  isLogin: false,
  searchObj: {
    keyword: '',
    searchVal: '商品'
  }, // 查询对象
  newAddress: {}, // 新增修改收货地址
  areaCode: [], // 当前区域编号
  currentPro: {}, // 当前商品
  userInfo: {
    headImage: ''
  }, // 当前用户信息
  shoppingCart: {}, // 购物车列表
  cartNumber: '', // 购物车数量
  homeSelectIndex: 0, // 首页tab 点击索引
  evaluateOrders: {}, // 评价订单
  noticeId: {}, // 公告id
  collectData: {} // 店铺数据
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js